import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.53 1.86H3.71a2.21 2.21 0 0 0-2.19 1.9.36.36 0 0 0 0 .1 1.77 1.77 0 0 0 0 .23v9.51a.73.73 0 0 0 .42.67.8.8 0 0 0 .33.08.75.75 0 0 0 .47-.17l3-2.45h6.81a2.23 2.23 0 0 0 2.22-2.22V4.09a2.23 2.23 0 0 0-2.24-2.23Zm.72 7.65a.72.72 0 0 1-.72.72H5.3a.42.42 0 0 0-.15 0 .53.53 0 0 0-.1.06L5 10.4h-.06L3 12V4.09a.73.73 0 0 1 .72-.73h8.82a.73.73 0 0 1 .72.73ZM1.5 3.86a1.77 1.77 0 0 0 0 .23V4a.34.34 0 0 1 0-.14Zm6.62 5.6a.74.74 0 0 1-.75-.75V7.18a.75.75 0 1 1 1.5 0v1.53a.75.75 0 0 1-.75.75ZM8.84 5a.72.72 0 0 1-.72.72.73.73 0 0 1-.73-.72.73.73 0 0 1 .73-.73.73.73 0 0 1 .72.73Z';
const draw24px =
  'M18,4.31H6A2.75,2.75,0,0,0,3.27,6.75a.28.28,0,0,0,0,.09,1.62,1.62,0,0,0,0,.22V20a.76.76,0,0,0,.43.68.71.71,0,0,0,.32.07.73.73,0,0,0,.47-.17l4.17-3.39H18a2.75,2.75,0,0,0,2.75-2.75V7.06A2.75,2.75,0,0,0,18,4.31Zm1.25,10.13A1.25,1.25,0,0,1,18,15.69H8.23l-.15.05L8,15.82l0,0L4.75,18.42V7.06A1.25,1.25,0,0,1,6,5.81H18a1.25,1.25,0,0,1,1.25,1.25Zm-16-7.6a1.62,1.62,0,0,0,0,.22V6.9A.13.13,0,0,1,3.26,6.84Zm5.12,8.85H8.23a.55.55,0,0,1,.22,0ZM12,14.11a.76.76,0,0,1-.75-.75V11.15a.75.75,0,1,1,1.5,0v2.21A.75.75,0,0,1,12,14.11Zm.87-5.68a.87.87,0,1,1-1.73,0,.87.87,0,0,1,1.73,0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ISpeechBubbleIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'iSpeechBubble')) as IconWithRender;

ISpeechBubbleIcon.displayName = 'ISpeechBubbleIcon';
ISpeechBubbleIcon.propTypes = Icon.propTypes;
ISpeechBubbleIcon.renderIcon = (props) => <ISpeechBubbleIcon {...props} />;
export default ISpeechBubbleIcon;
